import { Component, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SimplicateModal, simplicateModalOptions } from './simplicate-modal/simplicate-modal.component';
import { SettingsService } from '../../settings.service';
import { PermissionsEnum, PlatformSettings } from 'src/app/constants/settings.enum';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { Subscription } from 'rxjs';
import { OrganisationSettingsApiClient } from 'src/app/services/organisation-settings.apiclient';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { ConfigSalesforceModal } from './config-salesforce-modal/config-salesforce-modal.component';

@Component({
  templateUrl: './addressbook.page.html'
})
export class AddressbookPage implements OnDestroy {
  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;
  
  public AddressBookUrl: string = PKIUrls.AddressBookUrl;
  UseSimplicateCrmData: boolean = false;
  UseSalesforceCrmData: boolean = false;
  orgSettings!: any;
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private organisationSettingsApiClient: OrganisationSettingsApiClient, private modalService: NgbModal, private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService,
    private organisationApiClient: OrganisationApiClient,
    private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
      this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
        if (organisationId === this.selectedOrganisationId) return;
        this.selectedOrganisationId = organisationId;

        // setup specialised breadcrumb
        this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Integrations(this.selectedOrganisationId), BreadCrumbOptions.Integrations_Addressbook(this.selectedOrganisationId));

        this.getAddressbookSettings();
      });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }
  
  async getAddressbookSettings() {
    let addressbookSettings: PlatformSettings[] = [PlatformSettings.UseSimplicateCrmData, PlatformSettings.SimplicateApiKey, PlatformSettings.SimplicateApiSecret, PlatformSettings.SimplicateApiSubdomain, PlatformSettings.UseSalesforceCrmData, PlatformSettings.SalesforceApiKey, PlatformSettings.SalesforceApiSecret, PlatformSettings.SalesforceApiSubdomain];

    await this.organisationApiClient.getOrganisationSettingsByFilter(this.selectedOrganisationId, addressbookSettings).subscribe({
      next: (settings: any) => {
        let returnObject: any = {};
        settings.forEach((setting: any) => {
          returnObject[setting.key] = setting.value;
        });
        this.orgSettings = returnObject;
        this.orgSettings.UseSimplicateCrmData = (this.orgSettings.UseSimplicateCrmData == undefined || this.orgSettings.UseSimplicateCrmData == "" || this.orgSettings.UseSimplicateCrmData == "false") ? false : true;
        this.orgSettings.UseSalesforceCrmData = (this.orgSettings.UseSalesforceCrmData == undefined || this.orgSettings.UseSalesforceCrmData == "" || this.orgSettings.UseSalesforceCrmData == "false") ? false : true;
      }
    });
  }

  toggleShowSettings(event: any) {
    let key = (event.target as HTMLInputElement).id;
    let checked = (event.target as HTMLInputElement).checked;
    let updatedSettings: any[] = [{ key: key, value: checked }];
    
    if (key === "UseSalesforceCrmData") this.orgSettings.UseSalesforceCrmData = checked;
    if (key === "UseSimplicateCrmData") this.orgSettings.UseSimplicateCrmData = checked;
    
    this.settingsService.updateSettings(updatedSettings, this.selectedOrganisationId);
    if (checked) {
      this.openSimplicateModal();
    }
  }

  openConfigSalesforceModal(): void {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };
    let modalRef = this.modalService.open(ConfigSalesforceModal, ngbModalOptions);
    modalRef.componentInstance.organisationSettings = this.orgSettings;
    modalRef.componentInstance.updateOrganisationSettings.subscribe(async (item: any) => {
      this.settingsService.updateSettings(item, this.selectedOrganisationId);
      modalRef.close();
    });
  }
  
  openSimplicateModal(): void {
    let modalRef = this.modalService.open(SimplicateModal, simplicateModalOptions);
    modalRef.componentInstance.organisationSettings = this.orgSettings;
    modalRef.componentInstance.updateOrganisationSettings.subscribe(async (item: any) => {
      this.settingsService.updateSettings(item, this.selectedOrganisationId);
      modalRef.close();
    });
  }
}
